import React, { useMemo } from 'react';
import { Modal } from '../ui/Modal';
import { useGPS } from '../../contexts/GPSContext';
import { STATUS_FAMILIES, groupStatusesByCategory, getDraftStatuses } from '../../utils/gpsStatusCategories';

const GPSStatusMappingModal = ({ isOpen, onClose }) => {
  const gps = useGPS();
  const groups = useMemo(() => groupStatusesByCategory(gps.issues), [gps.issues]);
  const drafts = useMemo(() => getDraftStatuses(gps.issues), [gps.issues]);
  const hasAny = STATUS_FAMILIES.some((f) => groups[f.key]?.length > 0) || drafts.length > 0;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Correspondance des statuts" size="md">
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        Classification des status des workflows opérationnels du projet dans les catégories d'analyse.
        Seule la catégorie <span className="font-semibold">Clôturé</span> est discriminante : le mode
        « Fermés » = <span className="font-semibold">Clôturé</span>, « Encours » = tout le reste, et
        « Reçus » = tickets <span className="font-semibold">créés sur la période</span> (quel que soit le statut).
      </p>
      {!hasAny ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Aucun statut à afficher pour la sélection courante.
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3.5">
          {STATUS_FAMILIES.map((family) => {
            const statuses = groups[family.key] || [];
            return (
              <div key={family.key} className={`border rounded-xl p-4 ${family.wrap}`}>
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2 font-bold text-sm" style={{ color: family.color }}>
                    <span className="w-2.5 h-2.5 rounded-sm" style={{ background: family.color }} />
                    {family.label}
                  </div>
                  <span className="text-[11px] font-semibold text-gray-400 dark:text-gray-500">{statuses.length}</span>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {statuses.length === 0 ? (
                    <span className="text-[11px] text-gray-400 dark:text-gray-500 italic">Aucun</span>
                  ) : (
                    statuses.map((s) => (
                      <span key={s} className={`text-[11px] font-semibold rounded-md px-2.5 py-1 ${family.chip}`}>
                        {s}
                      </span>
                    ))
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {drafts.length > 0 && (
        <div className="mt-3.5 border border-dashed border-gray-300 dark:border-gray-700 rounded-xl p-4 bg-gray-50 dark:bg-gray-800/40">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2 font-bold text-sm text-gray-500 dark:text-gray-400">
              <span className="w-2.5 h-2.5 rounded-sm bg-gray-400" />
              Hors analyse · brouillons
            </div>
            <span className="text-[11px] font-semibold text-gray-400 dark:text-gray-500">{drafts.length}</span>
          </div>
          <p className="text-[11px] text-gray-400 dark:text-gray-500 mb-2.5">
            Tickets non finalisés, exclus des statistiques de l'onglet Général. Toujours visibles dans les onglets Secteurs et Tickets.
          </p>
          <div className="flex flex-wrap gap-1.5">
            {drafts.map((s) => (
              <span key={s} className="text-[11px] font-semibold rounded-md px-2.5 py-1 bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
                {s}
              </span>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default GPSStatusMappingModal;
